(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Read section ID from DOM — avoids Liquid output inside {% javascript %} block */
  var el = document.querySelector('.gt-bs[id^="gt-bs-"]');
  if (!el) return;
  var sid = el.id.replace('gt-bs-', '');
  var section = el;
  if (!section) return;

  function addToCart(variantId, btn) {
    if (!variantId || btn.disabled) return;

    btn.classList.add('is-adding');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    })
    .then(function () {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');

      /* Heritage CartAddEvent — matches CartAddEvent.eventName = 'cart:update'
         cart-drawer-component listens for this and calls showDialog() if auto-open */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: null,
          sourceId: sid,
          data: {
            itemCount: 1,
            source: 'gt-best-sellers',
            didError: false
          }
        }
      }));

      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1600);
    })
    .catch(function () {
      btn.classList.remove('is-adding');
      btn.disabled = false;
    });
  }

  /* Event delegation on section wrapper
     - Float button (.gt-bs__atc-float): type=button, NOT inside <a>, safe
     - Body ATC button (.gt-bs__btn-atc): type=button, in card body, safe
     - View link (.gt-bs__btn-pdp): tagName=A, skip it
     - Image link (.gt-bs__img-link): tagName=A, skip it */
  section.addEventListener('click', function (e) {
    /* If the click originated inside an <a> tag, let it navigate normally */
    if (e.target.closest('a')) return;

    var btn = e.target.closest('[data-variant-id]');
    if (!btn) return;

    /* Skip anchor tags — let them navigate normally */
    if (btn.tagName === 'A') return;

    /* This is a button with data-variant-id — it's an ATC button */
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    addToCart(variantId, btn);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrapper = document.querySelector('.gt-blog[id^="gt-blog-"]');
  if (!wrapper) return;

  var sid     = wrapper.id.replace('gt-blog-', '');
  var outer   = document.getElementById('gt-blog-outer-' + sid);
  var track   = document.getElementById('gt-blog-track-' + sid);
  var prevBtn = document.getElementById('gt-blog-prev-' + sid);
  var nextBtn = document.getElementById('gt-blog-next-' + sid);

  if (!outer || !track) return;

  var currentSlide = 0;
  var startX       = 0;
  var GAP          = 20;

  function isMobile()  { return window.innerWidth <= 749; }
  function isTablet()  { return window.innerWidth <= 989 && window.innerWidth > 749; }

  function visibleCards() {
    if (isMobile()) return 1.2;
    if (isTablet()) return 2.1;
    return 3.1;
  }

  function cardWidth() {
    var cpv = visibleCards();
    return (outer.offsetWidth - GAP * Math.floor(cpv)) / cpv;
  }

  function maxSlide() {
    var cards = track.querySelectorAll('.gt-blog__card');
    return Math.max(0, cards.length - Math.floor(visibleCards()));
  }

  function setCardWidths() {
    var w = cardWidth();
    track.querySelectorAll('.gt-blog__card').forEach(function (c) {
      c.style.flex = '0 0 ' + w + 'px';
    });
  }

  function applySlide() {
    var offset = currentSlide * (cardWidth() + GAP);
    track.style.transform = 'translateX(-' + offset + 'px)';
    if (prevBtn) prevBtn.disabled = currentSlide === 0;
    if (nextBtn) nextBtn.disabled = currentSlide >= maxSlide();
  }

  function goTo(idx) {
    currentSlide = Math.max(0, Math.min(idx, maxSlide()));
    applySlide();
  }

  function slide(dir) { goTo(currentSlide + dir); }

  function init() { setCardWidths(); applySlide(); }

  if (prevBtn) prevBtn.addEventListener('click', function () { slide(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { slide(1); });

  outer.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  outer.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) slide(diff > 0 ? 1 : -1);
  }, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      setCardWidths();
      currentSlide = 0;
      applySlide();
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-seasonal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrapper = document.querySelector('.gt-seas[id^="gt-seas-"]');
  if (!wrapper) return;

  var sid     = wrapper.id.replace('gt-seas-', '');
  var outer   = document.getElementById('gt-seas-outer-' + sid);
  var track   = document.getElementById('gt-seas-track-' + sid);
  var prevBtn = document.getElementById('gt-seas-prev-' + sid);
  var nextBtn = document.getElementById('gt-seas-next-' + sid);

  if (!outer || !track) return;

  var currentSlide = 0;
  var startX       = 0;
  var GAP          = 16;

  function isMobile() { return window.innerWidth <= 749; }
  function isTablet() { return window.innerWidth <= 989 && window.innerWidth > 749; }

  function getCards() {
    return Array.prototype.slice.call(track.querySelectorAll('.gt-seas__card'));
  }

  /* Cards per view — fractional peek intentional */
  function visibleCards() {
    if (isMobile()) return 1.5;
    if (isTablet()) return 2.8;
    return 4.2;
  }

  function cardWidth() {
    var outerW = outer.offsetWidth;
    var cpv    = visibleCards();
    return (outerW - GAP * Math.floor(cpv)) / cpv;
  }

  function maxSlide() {
    var cards = getCards();
    var cpv   = Math.floor(visibleCards());
    return Math.max(0, cards.length - cpv);
  }

  function setCardWidths() {
    var w = cardWidth();
    getCards().forEach(function (c) {
      c.style.flex = '0 0 ' + w + 'px';
    });
  }

  function applySlide() {
    var offset = currentSlide * (cardWidth() + GAP);
    track.style.transform = 'translateX(-' + offset + 'px)';
    if (prevBtn) prevBtn.disabled = currentSlide === 0;
    if (nextBtn) nextBtn.disabled = currentSlide >= maxSlide();
  }

  function goTo(idx) {
    currentSlide = Math.max(0, Math.min(idx, maxSlide()));
    applySlide();
  }

  function slide(dir) { goTo(currentSlide + dir); }

  function init() { setCardWidths(); applySlide(); }

  if (prevBtn) prevBtn.addEventListener('click', function () { slide(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { slide(1); });

  outer.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  outer.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) slide(diff > 0 ? 1 : -1);
  }, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      setCardWidths();
      currentSlide = 0;
      applySlide();
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-value-props"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Read section wrapper from DOM — no Liquid in JS block */
  var wrapper = document.querySelector('.gt-vp[id^="gt-vp-"]');
  if (!wrapper) return;

  var sid     = wrapper.id.replace('gt-vp-', '');
  var outer   = document.getElementById('gt-vp-outer-' + sid);
  var track   = document.getElementById('gt-vp-track-' + sid);
  var prevBtn = document.getElementById('gt-vp-prev-' + sid);
  var nextBtn = document.getElementById('gt-vp-next-' + sid);

  if (!outer || !track) return;

  var currentSlide = 0;
  var startX       = 0;
  var GAP          = 16;

  function getCards() {
    return Array.prototype.slice.call(track.querySelectorAll('.gt-vp__card--slide'));
  }

  function maxSlide() {
    return Math.max(0, getCards().length - 2);
  }

  function cardWidth() {
    return (outer.offsetWidth - GAP) / 2;
  }

  function setCardWidths() {
    var w = cardWidth();
    getCards().forEach(function (c) {
      c.style.flex = '0 0 ' + w + 'px';
    });
  }

  function applySlide() {
    var offset = currentSlide * (cardWidth() + GAP);
    track.style.transform = 'translateX(-' + offset + 'px)';
    if (prevBtn) prevBtn.disabled = currentSlide === 0;
    if (nextBtn) nextBtn.disabled = currentSlide >= maxSlide();
  }

  function goTo(idx) {
    currentSlide = Math.max(0, Math.min(idx, maxSlide()));
    applySlide();
  }

  function slide(dir) { goTo(currentSlide + dir); }

  function init() {
    setCardWidths();
    applySlide();
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { slide(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { slide(1); });

  outer.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  outer.addEventListener('touchend', function (e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) slide(diff > 0 ? 1 : -1);
  }, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      setCardWidths();
      currentSlide = 0;
      applySlide();
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
